import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    getSingleQuestion,
    setSelectedDemographic,
    getIeHeatmap,
    getSinglePastReport,
    setAddOnTabs,
    resetEmpExpResDataFetched,
    setBmDialog,
    getExFootnoteData,
    getScoreData,
    getCompType,
} from '../actions';
import { getReport, getRawPptData } from '../../Reports/actions';

import {
    selectApiCount,
    getErrorInfo,
    selectFilters,
    selectFiltersApplied,
    selectScoreData,
    selectSingleQuestion,
    selectSingleQuestionFetched,
    selectApiParams,
    selectSelectedDemographic,
    selectPastReport,
    selectAddOnTabs,
    selectExLeftBenchmarks,
    selectExRightBenchmarks,
    selectShowBmDialog,
    selectFootnoteListFetched,
    selectScoreDataFetched,
} from '../selector';

import { getDefaultSettings } from '../../Login/selector';
import IndExperience from './IndExperience';
import { selectReportError } from '../../Reports/selector';

const stateToProps = createStructuredSelector({
    apiLoadingCount: selectApiCount(),
    errorInfo: getErrorInfo(),
    defaultSettings: getDefaultSettings(),
    filters: selectFilters(),
    activeResetFilter: selectFiltersApplied(),
    scoreData: selectScoreData(),
    singleQuestion: selectSingleQuestion(),
    singleQuestionFetched: selectSingleQuestionFetched(),
    apiParams: selectApiParams(),
    selectedDemographics: selectSelectedDemographic(),
    reportError: selectReportError(),
    singlePastReport: selectPastReport(),
    addOnTab: selectAddOnTabs(),
    leftBenchmarks: selectExLeftBenchmarks(),
    rightBenchmarks: selectExRightBenchmarks(),
    showBmDialog: selectShowBmDialog(),
    footnoteListFetched: selectFootnoteListFetched(),
    scoreDataFetched: selectScoreDataFetched(),
});

const dispatchToProps = {
    getSingleQuestion,
    setSelectedDemographic,
    getIeHeatmap,
    getReport,
    getRawPptData,
    getSinglePastReport,
    setAddOnTabs,
    resetEmpExpResDataFetched,
    setBmDialog,
    getExFootnoteData,
    getScoreData,
    getCompType,
};

export default connect(stateToProps, dispatchToProps)(IndExperience);
